declare var API_URL_CONFIG: string;
declare var API_ENDPOINT_CONFIG: string;
declare var APP_VERSION_CONFIG: string;
declare var APP_RELEASE_CONFIG: string;
declare var AUKRO_URL_CONFIG: string;

export class AppSettings {
	// public static readonly API_URL = `${GLOBAL_API_URL}`;
	// public static readonly API_ENDPOINT = `${GLOBAL_API_ENDPOINT}`;

	public static readonly API_URL = API_URL_CONFIG;
	public static readonly API_ENDPOINT = API_ENDPOINT_CONFIG;
	public static readonly APP_VERSION = APP_VERSION_CONFIG;
	public static readonly APP_RELEASE = APP_RELEASE_CONFIG;
	public static readonly AUKRO_URL = AUKRO_URL_CONFIG;
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./app/core/services/app-settings.ts